import { bootcampOverviewGroq, bootcampOverviewModuleGroq, bootcampsListGroq } from '~/types/bootcamp'

/**
 * Set coming soon status to bootcamp that are not created on other locale e.g. no or ua,
 * so that the sub badges are visible on other locales.
 *
 * @param bootcampListDataObj Bootcamp List Data from Sanity
 * @returns Bootcamps List Data (name, intro, metaDescription, modules etc)
 */

function createBootcampsList({ bootcamps, reference }: bootcampsListGroq): bootcampOverviewGroq {
  const bootcampsMap = new Map()

  bootcamps.modules?.forEach((module) => {
    bootcampsMap.set(module.moduleNumber, module)
  })

  const updatedBootcampModules = reference.modules.reduce((list, currentReference): bootcampOverviewModuleGroq[] => {
    if (bootcampsMap.has(currentReference.moduleNumber)) {
      return [...list, bootcampsMap.get(currentReference.moduleNumber)]
    } else {
      return [
        ...list,
        {
          moduleNumber: currentReference.moduleNumber,
          badgeOutlineImage: currentReference.badgeOutlineImage,
          isUpcoming: true,
          chests: [],
          badgeImage: { srcKey: '' },
          levels: 0,
          progress: 0,
          hasWhyLevel: currentReference.hasWhyLevel,
          firstPageData: currentReference.firstPageData,
          name: currentReference.name,
          taskReferences: currentReference.mathPreview || null,
        },
      ]
    }
  }, [])

  return {
    ...bootcamps,
    modules: updatedBootcampModules,
  }
}

export default createBootcampsList
